var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 250,
    viewBox: "0 0 232 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1444 157.923V13.6891C94.1444 6.64291 99.7927 0.00109863 106.76 0.00109863H218.466C211.637 0.00109863 206.11 6.42506 205.891 13.2773V157.512C205.891 164.558 200.242 170.271 193.274 170.271H107.125H94.1842H81.5684C88.3972 170.271 93.9246 164.774 94.1444 157.923Z",
    fill: "url(#paint0_linear_6982_1332869)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.466 0.927021C225.433 0.927021 231.082 6.64069 231.082 13.6869V26.4453H205.849V13.6869C205.849 6.64069 211.498 0.927021 218.466 0.927021Z",
    fill: "url(#paint1_linear_6982_1332869)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5682 144.75H180.657V157.509C180.657 164.555 186.306 171.195 193.274 171.195H81.5682C81.5682 171.195 81.5372 171.195 81.521 171.195C74.5535 171.195 68.9052 164.555 68.9052 157.509V144.75H81.5682Z",
    fill: "#DFF0F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.274 171.436C200.737 171.436 206.808 165.295 206.808 157.749V13.5132C207.014 7.12207 212.134 2.0948 218.466 2.0948C224.918 2.0948 230.165 7.40109 230.165 13.9265V26.685H232V13.9265C232 6.37894 225.928 0.23848 218.466 0.23848C211.14 0.23848 205.213 6.05663 204.973 13.4834V157.749C204.973 164.273 199.726 169.579 193.274 169.579C186.823 169.579 181.575 164.273 181.575 157.749V144.989H179.74V157.749C179.74 165.295 185.812 171.436 193.274 171.436Z",
    fill: "#F7F9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6139 199.748V55.5134C43.6139 48.4671 49.2623 41.8253 56.2297 41.8253H167.936C161.107 41.8253 155.58 48.2493 155.36 55.1015V199.336C155.36 206.382 149.712 212.096 142.744 212.096H56.5942H43.6538H31.038C37.8667 212.096 43.3941 206.598 43.6139 199.748Z",
    fill: "url(#paint2_linear_6982_1332869)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.935 43.9126C174.903 43.9126 180.551 49.6263 180.551 56.6725V144.922H155.318V56.6725C155.318 49.6263 160.967 43.9126 167.935 43.9126Z",
    fill: "url(#paint3_linear_6982_1332869)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0377 186.575H130.127V199.333C130.127 206.379 135.775 213.02 142.743 213.02H31.0377C31.0377 213.02 31.0067 213.02 30.9905 213.02C24.023 213.02 18.3747 206.379 18.3747 199.333V186.575H31.0377Z",
    fill: "url(#paint4_linear_6982_1332869)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.744 213.26C150.206 213.26 156.278 207.119 156.278 199.573V55.3374C156.484 48.9463 161.604 43.919 167.935 43.919C174.387 43.919 179.634 49.2253 179.634 55.7508V149.807H181.47V55.7508C181.47 48.2032 175.398 42.0627 167.935 42.0627C160.609 42.0627 154.683 47.8808 154.443 55.3076V199.573C154.443 206.097 149.195 211.403 142.744 211.403C136.292 211.403 131.045 206.097 131.045 199.573V186.813H129.21V199.573C129.21 207.119 135.281 213.26 142.744 213.26Z",
    fill: "#F7F9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M164.737 235.508C164.737 243.536 127.824 250 82.3687 250C36.9134 250 0 243.536 0 235.508C0 227.48 36.9134 221.016 82.3687 221.016C127.824 221.016 164.737 227.48 164.737 235.508Z",
    fill: "url(#paint5_radial_6982_1332869)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_6982_1332869)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.7642 121.151C74.7642 108.151 85.2621 97.6599 98.1539 97.6599C103.213 97.6599 107.904 99.2756 111.736 102.025L78.644 134.114C76.1931 130.401 74.7642 125.947 74.7642 121.151ZM87.1335 141.875C90.4195 143.641 94.1725 144.642 98.1539 144.642C111.046 144.642 121.544 134.15 121.544 121.151C121.544 117.439 120.688 113.931 119.164 110.814L87.1335 141.875ZM98.1539 86.1875C78.8636 86.1875 63.2727 101.867 63.2727 121.151C63.2727 140.434 78.8636 156.114 98.1539 156.114C117.444 156.114 133.035 140.434 133.035 121.151C133.035 101.867 117.444 86.1875 98.1539 86.1875Z",
    fill: "url(#paint6_linear_6982_1332869)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_6982_1332869",
    x: 63.2727,
    y: 85.4875,
    width: 69.7622,
    height: 70.6258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6982_1332869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6982_1332869",
    x1: 123.455,
    y1: 18.5972,
    x2: 194.803,
    y2: 167.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DBF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6982_1332869",
    x1: 218.466,
    y1: 26.6005,
    x2: 218.466,
    y2: 0.925827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DBF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6982_1332869",
    x1: 159.63,
    y1: 169.578,
    x2: 99.8338,
    y2: 154.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6982_1332869",
    x1: 167.935,
    y1: 68.4247,
    x2: 167.935,
    y2: 42.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DBF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6982_1332869",
    x1: 80.5596,
    y1: 213.339,
    x2: 78.0365,
    y2: 187.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7DBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631796,
    stopColor: "#DFF8F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F9FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6982_1332869",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.2981 235.33) scale(82.3956 14.4433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCDBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515067,
    stopColor: "#BDD0E3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746289,
    stopColor: "#B0D0F2",
    stopOpacity: 0.1656
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0D0F2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6982_1332869",
    x1: 54.5815,
    y1: 127.543,
    x2: 145.504,
    y2: 120.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7C2CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7C2CE",
    stopOpacity: 0.01
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.ece63db712107d8081ebac04c50e8f52.svg";
export { ForwardRef as ReactComponent };